<template>
  <div class="container">
    <CheckBoxStandard
      :checked="checked"
      :title="t('general__text__bookable-rooms')"
      @valueChanged="updateOnlyBookable"
    />
    <InfoLabel :size="'mediumBold'" :info="t('general__text__bookable-rooms-info')" />
  </div>
</template>

<script lang="ts" setup>
import { useI18n } from 'vue-i18n'
import CheckBoxStandard from '@/design-system/atoms/CheckBoxStandard.vue'
import InfoLabel from '@/design-system/molecules/InfoLabel.vue'
const { t } = useI18n()
type Emits = {
  (e: 'selectionChanged', checked: boolean)
}
const emits = defineEmits<Emits>()
type Props = {
  checked: boolean
}
defineProps<Props>()
const updateOnlyBookable = (e: any): void => {
  emits('selectionChanged', e.target.checked)
}
</script>

<style lang="scss" scoped>
.container {
  display: flex;
  flex-direction: row;
  align-items: center;
}
</style>
